import React from 'react';
import Icon from 'components/Utils/NewIcon';
import { useAppSelector } from 'careand-redux/store';
import StaffUtils from 'services/StaffUtils';
import { MedicalOrder, Patient } from 'generated/api';

const CPPTimelineMedicalOrder = ({
  order,
  onClick,
}: {
  order: MedicalOrder;
  patient: Patient;
  onClick: (order?: MedicalOrder) => void;
}) => {
  const admins = useAppSelector((state) => state.admins.byId);
  const physicians = useAppSelector((state) => state.physicians.byId);
  const name = StaffUtils.getName(admins[order.author_id] || physicians[order.author_id]);

  return (
    <div className="item-wrapper clickable" data-tip onClick={() => onClick(order)}>
      <div className="top-bar">
        <Icon src="note" />
        <span className="small-title">Medical Order</span>
      </div>
      <div className="item-content">
        <span>
          {name}
          <br />
        </span>
        {order?.medications?.length! > 0 && (
          <div>
            {order.medications?.map((medication, index) => (
              <span key={index}>
                {medication.name}
                <br />
              </span>
            ))}
          </div>
        )}
        <span>{order.text}</span>
      </div>
    </div>
  );
};

export default CPPTimelineMedicalOrder;
